<template>
  <div class="pageBox" :lang="isArab?'ar' : 'en'" :dir="isArab?'rtl' : 'ltr'">
      <div class="newbox">
          
          <div class="quesUl">
              <div class="quesLi" v-for="(item, index1) in newQuesArr" v-bind:key="index1">
                  <div class="showArea" @click="showDetailDesc(index1)">
                      <div class="detailText">{{item.ques}}</div>
                      <div class="downIcon" >
                          <img src="./../assets/arrow_up_new.png" v-if="newQuesArrShowIndex == index1">
                          <img src="./../assets/arrow_down_new.png" v-if="!(newQuesArrShowIndex == index1)">
                      </div>
                  </div>
                  <div class="hideArea" v-if="newQuesArrShowIndex == index1">
                     <div class="quesDetailText">
                         <p>{{item.answer}}</p>
                         <br/>
                         <p v-for="(itemli,index) in item.answerItem" v-bind:key="index">{{index+1}}. {{itemli.itemText}}</p>
                         <div class="toFeedBack" @click="toFeedBackPage(index1)">
                             <p>{{toFeed}}</p>
                         </div>
                     </div>
                  </div>
              </div>
          </div>
      </div>
      
  </div>
</template>

<script>
import {popularQuesData} from './../json/data'
import {_di} from './../common/js/di';
export default {
  name: 'CategoryDetail',
  data () {
    return {
      title: "Help",
      newQuesArr: [],
      newQuesArrShowIndex: null,
      indexNum: 0,
      isArab: false,
      toFeed: "Still need help? Click here send feedback >",
      eventTrack:null,
      userId: '',
    }
  },
  beforeCreate(){
     
  },
  mounted(){
    var lang = this.getUrlParam("lang");
    this.userId = this.getUrlParam('userId') || 120058;
    if(!!lang){
        this.isArab = lang == "ar"?true: false;
    }else{
        this.isArab = this.$route.query.isArab;
    }
    if(this.isArab == "false"){
      this.isArab = false
    }
    this.indexNum = this.$route.query.indexNum;
    this.toFeed = this.isArab ? "تحتاج للمزيد من المساعدة، اضغط هنا لإرسال إستفساراتك وإقتراحتك." : "Still need help? Click here send feedback >";
    this.title = this.isArab ? popularQuesData["ar"][this.indexNum].title : popularQuesData["en"][this.indexNum].title;
    document.title = this.title;
    this.newQuesArr = this.isArab ? popularQuesData["ar"][this.indexNum].detailArr : popularQuesData["en"][this.indexNum].detailArr;
    // console.log(this.indexNum);
    // console.log(process.env);
    //di打点相关
    this.eventTrack = {
        helppageenter: _di('settings.help',42614),
        topicclick: _di('help.topics',42615),
        answerclick: _di('help.answer',42616),
        helplinkclick: _di('help.contact',42617),
    }
  },
  methods: {
    test(){
       console.log(88888);
    },
    showDetailDesc(index){
        console.log(index,this.newQuesArrShowIndex)
       if(this.newQuesArrShowIndex == index){
           this.newQuesArrShowIndex = null;
       }else{
           this.newQuesArrShowIndex = index;
       }
       //打点
        this.eventTrack.answerclick({
            "user_id": this.userId,
            "question_id": index,
            "topic_id": this.indexNum,
        });
    },
    toFeedBackPage(index){
        //打点
        this.eventTrack.helplinkclick({
            "user_id": this.userId,
            "question_id": index,
            "topic_id": this.indexNum,
        });
        var linkurl = "loopsmozat://general/feedback";
        window.location.href = linkurl;
    },
    getUrlParam(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    },
 
  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .pagebox{
     width: 100%;
  }
  .titleArea{
    width: 100%;
    height: 0.64rem;
    background: rgb(250, 250, 250);
    display: flex;
    justify-content: center;
  }
  .titleText{
    width: 3.45rem;
    height: 0.44rem;
    line-height: 0.44rem;
    margin-top: 0.2rem;
    font-size: 0.2rem;
    color: rgb(38,39, 41);
    font-weight: bolder;
  }
  .quesUl{
     width: 100%;
     position: relative;
  }
  .quesUl:after {
    content: '';
    position: absolute;
    left: 0;
    bottom:0;
    background: rgb(232, 232, 232);
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    z-index: -1;
}
  .quesLi{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .quesLi:after {
    content: '';
    position: absolute;
    left: 0;
    bottom:0;
    background: rgb(232, 232, 232);
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    z-index: -1;
}
  .showArea{
    width: 3.45rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .detailText{
     width: 3rem;
     line-height: 0.18rem;
     font-size: 0.14rem;
     color: rgb(38, 39, 41);
     margin: 0.22rem 0;
     font-weight: bolder;
  }
  .detailText2{
     width: 3rem;
     line-height: 0.18rem;
     font-size: 0.14rem;
     color: rgb(38, 39, 41);
     margin: 0.14rem 0;
     font-weight: bolder;
  }
  .topicText1{
     color: rgb(0, 0, 0);
     font-weight: bolder;
     font-size: 0.16rem;
     line-height: 0.2rem;
  }
  .topicText2{
     color: rgb(178,178,178);
     font-size: 0.14rem;
     line-height: 0.18rem;
     font-weight: normal;
  }
  .downIcon{
    width: 0.3rem;
    height: 0.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .downIcon img{
    width: 0.2rem;
  }
  .hideArea{
     width: 3.45rem;
  }
  .quesDetailText{
      width: 3rem;
      
  }
  .quesDetailText p{
      font-size: 0.14rem;
      color: rgb(0, 0, 0);
      line-height: 0.16rem;
  }
  .toFeedBack{
      width: 100%;
      height: 0.66rem;
      display: flex;
      align-items: center;
  }
  .toFeedBack p{
      line-height: 0.16rem;
      font-size: 0.14rem;
      color: #51d287;
      font-weight: bolder;
      text-decoration: underline;
  }
</style>


// WEBPACK FOOTER //
// src/components/CategoryDetail.vue